import { Ease, Tween } from "@westpierstudio/luma/createjs";
import { AssetSpec, SpriteAssetSpec, TextAssetSpec } from "@westpierstudio/luma/factory/PixiFactory";
import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";
import { Sprite, Text, Texture } from "pixi.js";
import { OrientationSpec } from "servertypes/SharedTypes";
import { Signal } from "type-signals";
import { Bounds, implementBoundedContainer } from "utils/BoundedContainer";

interface TouchStartFreeSpinsSpec extends AssetSpec {
    position: OrientationSpec<AssetSpec>,
    dim: SpriteAssetSpec
    text: TextAssetSpec
    flicker: { on: number, off: number, fade: number }
    textBounds: Bounds
}

export class TouchStartFreeSpins extends View {

    spec: TouchStartFreeSpinsSpec;
    dim: Sprite;
    message: Text;
    signals = {
        complete: new Signal(),
    };

    constructor(protected override readonly services: GameServices) {
        super(services);
        const { factory, layout, resources } = services;

        const spec = this.spec = resources.getSpec(`touchstartfreespins`) as TouchStartFreeSpinsSpec;
        factory.applySpec(this, this.spec.position[layout.orientation]);

        this.dim = factory.createSpriteFromTexture(Texture.WHITE, spec.dim, this);
        this.dim.tint = 0x0;
        this.alpha = 0;
        this.visible = false;

        implementBoundedContainer(this.message = factory.createText(resources.getMessage(`touchToStartFreeSpins`), spec.text, this), spec.textBounds);

        layout.onResize.add(() => this.resize());
        layout.onReorient.add(() => this.reorient());
        this.resize();
    }


    private reorient(): void {
        const { factory, layout } = this.services;
        factory.applySpec(this, this.spec.position[layout.orientation]);
    }

    show() {
        this.visible = true;
        this.alpha = 0;
        this.startMessageBlink();
        Tween.get(this)
            .to({ alpha: 1 }, 500);
    }

    startMessageBlink() {
        const { on, off, fade } = this.spec.flicker;
        this.message.alpha = 1;
        Tween.get(this.message)
            .wait(on - fade)
            .to({ alpha: 0 }, fade)
            .wait(off - fade)
            .to({ alpha: 1 }, fade)
            .loop = -1;
    }

    hide() {
        Tween.removeTweens(this);
        Tween.removeTweens(this.message);
        Tween.get(this)
            .to({ alpha: 0 }, 500)
            .call(() => {
                this.signals.complete.dispatch();
                this.visible = false;
                Tween.removeTweens(this.message);
            });
    }

    resize(): void {
        const bounds = this.services.layout.getScreenBoundaryInBucketSpace();
        this.dim.width = bounds.width * 2;
        this.dim.height = bounds.height * 2;
    }
}